import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Download, X } from 'lucide-react';

/**
 * Register the service worker on mount and surface a small in-app
 * "Install Bison Shop" prompt when the browser fires beforeinstallprompt.
 */
export const PWAInstaller = () => {
  const [deferredEvt, setDeferredEvt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      navigator.serviceWorker.register('/service-worker.js').catch(() => null);
    }
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferredEvt(e);
      if (!localStorage.getItem('pwa_install_dismissed')) {
        setShow(true);
      }
    };
    const onInstalled = () => { setShow(false); setDeferredEvt(null); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (!show || !deferredEvt) return null;

  const install = async () => {
    try {
      await deferredEvt.prompt();
      const choice = await deferredEvt.userChoice;
      if (choice?.outcome !== 'accepted') localStorage.setItem('pwa_install_dismissed', '1');
    } catch { /* ignore */ }
    setShow(false);
    setDeferredEvt(null);
  };

  const dismiss = () => {
    localStorage.setItem('pwa_install_dismissed', '1');
    setShow(false);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 bg-white border border-border rounded-xl shadow-xl p-4 z-50" data-testid="pwa-install-prompt">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1">
          <div className="font-semibold text-sm">Install Bison Shop</div>
          <p className="text-xs text-muted-foreground mt-0.5">Add Bison Shop to your home screen for fast access and offline browsing.</p>
          <div className="mt-2 flex gap-2">
            <Button size="sm" onClick={install} data-testid="pwa-install-btn">Install</Button>
            <Button size="sm" variant="ghost" onClick={dismiss} data-testid="pwa-dismiss-btn">Not now</Button>
          </div>
        </div>
        <button onClick={dismiss} className="text-muted-foreground hover:text-foreground"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
